import {
  Avatar,
  Box,
  Button,
  Checkbox, Collapse,
  Flex,
  FormControl,
  FormLabel,
  Icon,
  Input, InputGroup, InputRightElement, List, ListIcon, ListItem, Spinner,
  Stack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
// Custom components
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";
import React, { useEffect, useRef, useState} from "react";
import {BsCircleFill} from "react-icons/bs";
import {FaApplePay, FaGooglePay, FaIdeal} from "react-icons/fa";
import {getCompanyName} from "../../../extensions/stylingExstension";
import {getUserName} from "../../../extensions/userInfoExtension";
import {WarningIcon} from "@chakra-ui/icons";
import OrderDetails from "./Components/OrderDetails";
import {createSubscription, PaymentMethods} from "../../../api/paymentService";
import {getUser, putUser} from "../../../api/userService";

function Wizard() {
  const textColor = useColorModeValue("gray.700", "white");
  const bgPrevButton = useColorModeValue("gray.100", "gray.100");
  const iconColor = useColorModeValue("gray.300", "gray.700");

  const [isLoadingUserData, setIsLoadingUserData] = useState(true);
  const [isRedirecting, setIsRedirecting] = useState(false);
  const [userData, setUserData] = useState({
    firstName: "",
    lastName: ""
  });

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await getUser();
        if(response.hasSubscription === true){
          // window.location.href = '/';
        }
        setUserData({
          firstName: response.firstName === undefined ? "" : response.firstName,
          lastName: response.lastName === undefined ? "" : response.lastName,
        });
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoadingUserData(false);
      }
    };

    const response = fetchUserData();
  }, []);


  const [activeBullets, setActiveBullets] = useState({
    gegevens: true,
    betaalmethode: false,
    overzicht: false,
  });

  const [checkboxes, setCheckboxes] = useState({
    iDEAL: false,
    ApplePay: false,
    GooglePay: false,
  });

  const gegevensTab = useRef();
  const betaalmethodeTab = useRef();
  const overzichtTab = useRef();

  const getPaymentMethod = () => {
    if (checkboxes.iDEAL) {
      return PaymentMethods.iDEAL;
    }

    if (checkboxes.ApplePay) {
      return PaymentMethods.ApplePay;
    }

    if (checkboxes.GooglePay) {
      return PaymentMethods.GooglePay;
    }
  }

  return (
    <Flex
      direction="column"
      minH="100vh"
      align="center"
      pt={{sm: "125px", lg: "75px"}}
    >
      <Flex
        direction="column"
        textAlign="center"
        mb={{sm: "25px", md: "45px"}}
      >
        <Text
          color={textColor}
          fontSize={{sm: "2xl", md: "3xl", lg: "4xl"}}
          fontWeight="bold"
          mb="8px"
        >
          Word premium lid!
        </Text>
        <Text
          color="gray.400"
          fontWeight="normal"
          fontSize={{sm: "sm", md: "lg"}}
        >
          Geniet van onbeperkt notuleren als premium lid van {getCompanyName()}.
        </Text>
      </Flex>
      <Tabs variant="unstyled" mt="24px" display="flex" flexDirection="column">
        <TabList
          display="flex"
          align="center"
          alignSelf="center"
          justifySelf="center"
        >
          <Tab
            ref={gegevensTab}
            _focus="none"
            w={{sm: "120px", md: "250px", lg: "300px"}}
            onClick={() => {
              setActiveBullets({
                gegevens: true,
                betaalmethode: false,
                overzicht: false,
              });
            }}
          >
            <Flex
              direction="column"
              justify="center"
              align="center"
              position="relative"
              _before={{
                content: "''",
                width: {sm: "120px", md: "250px", lg: "300px"},
                height: "3px",
                bg: activeBullets.betaalmethode ? textColor : "gray.200",
                left: {sm: "12px", md: "26px"},
                top: {sm: activeBullets.gegevens ? "6px" : "4px", md: null},
                position: "absolute",
                bottom: activeBullets.gegevens ? "40px" : "38px",
                zIndex: -1,
                transition: "all .3s ease",
              }}
            >
              <Icon
                as={BsCircleFill}
                color={activeBullets.gegevens ? textColor : "gray.300"}
                w={activeBullets.gegevens ? "16px" : "12px"}
                h={activeBullets.gegevens ? "16px" : "12px"}
                mb="8px"
              />
              <Text
                color={activeBullets.gegevens ? {textColor} : "gray.300"}
                fontWeight={activeBullets.gegevens ? "bold" : "normal"}
                display={{sm: "none", md: "block"}}
                fontSize="sm"
              >
                Gegevens
              </Text>
            </Flex>
          </Tab>
          <Tab
            ref={betaalmethodeTab}
            _focus="none"
            w={{sm: "120px", md: "250px", lg: "300px"}}
            onClick={() => {
              setActiveBullets({
                gegevens: true,
                betaalmethode: true,
                overzicht: false,
              })
            }}
          >
            <Flex
              direction="column"
              justify="center"
              align="center"
              position="relative"
              _before={{
                content: "''",
                width: {sm: "120px", md: "250px", lg: "300px"},
                height: "3px",
                bg: activeBullets.overzicht ? textColor : "gray.200",
                left: {sm: "12px", md: "28px"},
                top: {sm: activeBullets.betaalmethode ? "6px" : "4px", md: null},
                position: "absolute",
                bottom: activeBullets.betaalmethode ? "40px" : "38px",
                zIndex: -1,
                transition: "all .3s ease",
              }}
            >
              <Icon
                as={BsCircleFill}
                color={activeBullets.betaalmethode ? textColor : "gray.300"}
                w={activeBullets.betaalmethode ? "16px" : "12px"}
                h={activeBullets.betaalmethode ? "16px" : "12px"}
                mb="8px"
              />
              <Text
                color={activeBullets.betaalmethode ? {textColor} : "gray.300"}
                fontWeight={activeBullets.betaalmethode ? "bold" : "normal"}
                transition="all .3s ease"
                fontSize="sm"
                _hover={{color: textColor}}
                display={{sm: "none", md: "block"}}
              >
                Betaalmethode
              </Text>
            </Flex>
          </Tab>
          <Tab
            ref={overzichtTab}
            _focus="none"
            w={{sm: "120px", md: "250px", lg: "300px"}}
            onClick={() =>
              setActiveBullets({
                gegevens: true,
                betaalmethode: true,
                overzicht: true,
              })
            }
          >
            <Flex
              direction="column"
              justify="center"
              align="center"
              position="relative"
              _before={{
                content: "''",
                width: {sm: "120px", md: "250px", lg: "300px"},
                height: "3px",
                left: {sm: "12px", md: "32px"},
                top: {sm: activeBullets.overzicht ? "6px" : "4px", md: null},
                position: "absolute",
                bottom: activeBullets.overzicht ? "40px" : "38px",
                zIndex: -1,
                transition: "all .3s ease",
              }}
            >
              <Icon
                as={BsCircleFill}
                color={activeBullets.overzicht ? textColor : "gray.300"}
                w={activeBullets.overzicht ? "16px" : "12px"}
                h={activeBullets.overzicht ? "16px" : "12px"}
                mb="8px"
              />
              <Text
                color={activeBullets.overzicht ? {textColor} : "gray.300"}
                fontWeight={activeBullets.overzicht ? "bold" : "normal"}
                transition="all .3s ease"
                fontSize="sm"
                _hover={{color: textColor}}
                display={{sm: "none", md: "block"}}
              >
                Overzicht
              </Text>
            </Flex>
          </Tab>
        </TabList>
        <TabPanels mt="24px" maxW={{md: "90%", lg: "100%"}} mx="auto">
          <TabPanel w={{sm: "330px", md: "700px", lg: "850px"}} mx="auto">
            <Card>
              <CardHeader mb="40px">
                <Flex
                  direction="column"
                  align="center"
                  justify="center"
                  textAlign="center"
                  w="80%"
                  mx="auto"
                >
                  <Text
                    color={textColor}
                    fontSize="lg"
                    fontWeight="bold"
                    mb="4px"
                  >
                    Uw gegevens
                  </Text>
                  <Text color="gray.400" fontWeight="normal" fontSize="sm">
                    Om premium lid te worden hebben we de volgende gegevens van u nodig.
                  </Text>
                </Flex>
              </CardHeader>
              <CardBody>
                <Flex direction="column" w="100%">
                  <Flex
                    direction={{sm: "column", md: "row"}}
                    w="100%"
                    mb="24px"
                  >
                    <Box
                      position="relative"
                      minW={{sm: "110px", xl: "150px"}}
                      h={{sm: "110px", xl: "150px"}}
                      mx={{sm: "auto", md: "40px", xl: "85px"}}
                      mb={{sm: "25px"}}
                    >
                      <Avatar
                        name={getUserName()}
                        w="100%"
                        h="100%"
                        borderRadius="12px"
                      />
                    </Box>
                    <Stack direction="column" spacing="20px" w="100%">
                      <FormControl>
                        <FormLabel
                          color={textColor}
                          fontSize="xs"
                          fontWeight="bold"
                        >
                          Voornaam
                        </FormLabel>
                        <InputGroup>
                          <Input
                            borderRadius="15px"
                            fontSize="xs"
                            onChange={(e) =>
                              setUserData((prev) => ({
                                ...prev,
                                firstName: e.target.value,
                              }))
                            }
                            value={userData.firstName}
                          />
                          {isLoadingUserData && (
                            <InputRightElement>
                              <Spinner size="sm"/>
                            </InputRightElement>
                          )}
                        </InputGroup>
                        <Collapse in={userData.firstName?.trim() === "" && isLoadingUserData === false} animateOpacity>
                          <List spacing={5}>
                            <ListItem fontSize="xs">
                              <ListIcon fontSize="md" as={WarningIcon} color="red.500"/>
                              Voornaam is verplicht
                            </ListItem>
                          </List>
                        </Collapse>
                      </FormControl>
                      <FormControl>
                        <FormLabel
                          color={textColor}
                          fontSize="xs"
                          fontWeight="bold"
                        >
                          Achternaam
                        </FormLabel>
                        <InputGroup>
                          <Input
                            borderRadius="15px"
                            fontSize="xs"
                            onChange={(e) =>
                              setUserData((prev) => ({
                                ...prev,
                                lastName: e.target.value,
                              }))
                            }
                            value={userData.lastName}
                          />
                          {isLoadingUserData && (
                            <InputRightElement>
                              <Spinner size="sm"/>
                            </InputRightElement>
                          )}
                        </InputGroup>

                        <Collapse in={userData.lastName?.trim() === "" && isLoadingUserData === false} animateOpacity>
                          <List spacing={5}>
                            <ListItem fontSize="xs">
                              <ListIcon fontSize="md"
                                        as={WarningIcon} color="red.500"/>
                              Achternaam is verplicht
                            </ListItem>
                          </List>
                        </Collapse>
                      </FormControl>
                      <FormControl>
                        <FormLabel
                          color={textColor}
                          fontSize="xs"
                          fontWeight="bold"
                        >
                          Email adres
                        </FormLabel>
                        <Input
                          borderRadius="15px"
                          placeholder={getUserName()}
                          fontSize="xs"
                          isReadOnly
                        />
                      </FormControl>
                    </Stack>
                  </Flex>
                  <Button
                    variant="no-hover"
                    bg="linear-gradient(81.62deg, #313860 2.25%, #151928 79.87%)"
                    alignSelf="flex-end"
                    mt="24px"
                    w={{sm: "75px", lg: "100px"}}
                    h="35px"
                    onClick={async () => {
                      if (userData?.firstName !== "" && userData?.lastName !== "") {
                        betaalmethodeTab.current.click();
                      }
                    }}
                  >
                    <Text fontSize="xs" color="#fff" fontWeight="bold">
                      {"VOLGENDE".toUpperCase()}
                    </Text>
                  </Button>
                </Flex>
              </CardBody>
            </Card>
          </TabPanel>
          <TabPanel w={{sm: "330px", md: "700px", lg: "850px"}} mx="auto">
            <Card>
              <CardHeader mb="40px">
                <Flex
                  direction="column"
                  align="center"
                  justify="center"
                  textAlign="center"
                  w="80%"
                  mx="auto"
                >
                  <Text
                    color={textColor}
                    fontSize="lg"
                    fontWeight="bold"
                    mb="4px"
                  >
                    Betaalmethode
                  </Text>
                  <Text color="gray.400" fontWeight="normal" fontSize="sm">
                    Kies uw gewenste betaalmethode
                  </Text>
                </Flex>
              </CardHeader>
              <CardBody>
                <Flex direction="column" w="100%">
                  <Stack
                    direction={{sm: "column", md: "row"}}
                    spacing={{sm: "20px", lg: "35px"}}
                    alignSelf="center"
                    justifySelf="center"
                    mb="24px"
                  >
                    <Flex direction="column" align="center">
                      <FormLabel w="150px" h="150px" cursor="pointer" mb="16px">
                        <Flex
                          w="100%"
                          h="100%"
                          borderRadius="12px"
                          justify="center"
                          transition=".5s all ease"
                          border="1px solid lightgray"
                          align="center"
                          bg={checkboxes.iDEAL ? "var(--title-color)" : "#fff"}
                          _hover={{opacity: "0.8"}}
                        >
                          <Checkbox
                            onChange={() => setCheckboxes({
                                iDEAL: true,
                                ApplePay: false,
                                GooglePay: false
                              }
                            )}
                            display="none"
                          />
                          <Icon
                            as={FaIdeal}
                            w="54px"
                            h="54px"
                            color={checkboxes.iDEAL ? "#fff" : iconColor}
                          />
                        </Flex>
                      </FormLabel>
                    </Flex>
                    <Flex direction="column" align="center">
                      <FormLabel w="150px" h="150px" cursor="pointer" mb="16px">
                        <Flex
                          w="100%"
                          h="100%"
                          borderRadius="12px"
                          justify="center"
                          transition=".5s all ease"
                          border="1px solid lightgray"
                          align="center"
                          bg={checkboxes.ApplePay ? "var(--title-color)" : "#fff"}
                          _hover={{opacity: "0.8"}}
                        >
                          <Checkbox
                            onChange={() => setCheckboxes({
                                iDEAL: false,
                                ApplePay: true,
                                GooglePay: false
                              }
                            )}
                            display="none"
                          />
                          <Icon
                            as={FaApplePay}
                            w="54px"
                            h="54px"
                            color={checkboxes.ApplePay ? "#fff" : iconColor}
                          />
                        </Flex>
                      </FormLabel>
                    </Flex>
                    {/*<Flex direction="column" align="center">*/}
                    {/*  <FormLabel w="150px" h="150px" cursor="pointer" mb="16px">*/}
                    {/*    <Flex*/}
                    {/*      w="100%"*/}
                    {/*      h="100%"*/}
                    {/*      borderRadius="12px"*/}
                    {/*      justify="center"*/}
                    {/*      transition=".5s all ease"*/}
                    {/*      border="1px solid lightgray"*/}
                    {/*      align="center"*/}
                    {/*      bg={checkboxes.GooglePay ? "var(--title-color)" : "#fff"}*/}
                    {/*      _hover={{opacity: "0.8"}}*/}
                    {/*    >*/}
                    {/*      <Checkbox*/}
                    {/*        onChange={() => setCheckboxes({*/}
                    {/*            iDEAL: false,*/}
                    {/*            ApplePay: false,*/}
                    {/*            GooglePay: true*/}
                    {/*          }*/}
                    {/*        )}*/}
                    {/*        display="none"*/}
                    {/*      />*/}
                    {/*      <Icon*/}
                    {/*        as={FaGooglePay}*/}
                    {/*        w="54px"*/}
                    {/*        h="54px"*/}
                    {/*        color={checkboxes.GooglePay ? "#fff" : iconColor}*/}
                    {/*      />*/}
                    {/*    </Flex>*/}
                    {/*  </FormLabel>*/}
                    {/*</Flex>*/}
                  </Stack>

                  <Flex justify="space-between">
                    <Button
                      variant="no-hover"
                      bg={bgPrevButton}
                      alignSelf="flex-end"
                      mt="24px"
                      w={{sm: "75px", lg: "100px"}}
                      h="35px"
                      onClick={() => {
                        gegevensTab.current.click()
                      }}
                    >
                      <Text fontSize="xs" color="gray.700" fontWeight="bold">
                        {"VORIGE".toUpperCase()}
                      </Text>
                    </Button>
                    <Button
                      variant="no-hover"
                      bg="linear-gradient(81.62deg, #313860 2.25%, #151928 79.87%)"
                      alignSelf="flex-end"
                      mt="24px"
                      w={{sm: "75px", lg: "100px"}}
                      h="35px"
                      onClick={() => {
                        if (checkboxes.iDEAL !== false || checkboxes.ApplePay !== false || checkboxes.GooglePay !== false) {
                          overzichtTab.current.click();
                        }
                      }}
                    >
                      <Text fontSize="xs" color="#fff" fontWeight="bold">
                        {"VOLGENDE".toUpperCase()}
                      </Text>
                    </Button>
                  </Flex>
                </Flex>
              </CardBody>
            </Card>
          </TabPanel>
          <TabPanel w={{sm: "330px", md: "700px", lg: "850px"}} mx="auto">
            <Card>
              <CardHeader mb="40px">
                <Flex
                  direction="column"
                  align="center"
                  justify="center"
                  textAlign="center"
                  w="80%"
                  mx="auto"
                >
                  <Text
                    color={textColor}
                    fontSize="lg"
                    fontWeight="bold"
                    mb="4px"
                  >
                    {`Overzicht: ${getCompanyName()} maandelijkse subscriptie`}
                  </Text>
                  <Text color="gray.400" fontWeight="light" fontStyle="italic" fontSize="sm">
                    Jij praat, wij notuleren – automatisch en accuraat.
                  </Text>
                  <Text color="gray.400" fontWeight="normal" fontSize="sm">
                    Onbeperkt notuleren, inclusief gebruik van alle premium features.
                  </Text>
                </Flex>
              </CardHeader>
              <CardBody>
                <Flex direction="column" w="100%">
                  <OrderDetails
                    Name={userData.firstName + " " + userData.lastName}
                    Email={getUserName()}
                    PaymentMethod={getPaymentMethod()}
                  />
                  <Flex justify="space-between">
                    <Button
                      variant="no-hover"
                      bg={bgPrevButton}
                      alignSelf="flex-end"
                      mt="24px"
                      w={{sm: "75px", lg: "100px"}}
                      h="35px"
                      onClick={() => betaalmethodeTab.current.click()}
                    >
                      <Text fontSize="xs" color="gray.700" fontWeight="bold">
                        {"VORIGE".toUpperCase()}
                      </Text>
                    </Button>
                    <Button
                      isLoading={isRedirecting}
                      isDisabled={isRedirecting}
                      bg={!isRedirecting ?  "linear-gradient(81.62deg, #313860 2.25%, #151928 79.87%)" : ""}
                      alignSelf="flex-end"
                      mt="24px"
                      w={{sm: "75px", lg: "100px"}}
                      h="35px"
                      onClick={async () => {
                        setIsRedirecting(true);
                        await putUser(userData.firstName, userData.lastName);
                        const response = await createSubscription(getPaymentMethod());
                        if (response?.paymentLink) {
                          window.location.href = response.paymentLink;
                        } else {
                          console.log(response);
                        }
                      }}
                    >
                      <Text fontSize="xs" color="#fff" fontWeight="bold">
                        {"Afrekenen".toUpperCase()}
                      </Text>
                    </Button>
                  </Flex>
                </Flex>
              </CardBody>
            </Card>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Flex>
  );
}

export default Wizard;
